import {tracker} from 'payment-widget-core/tracker'
import openReplayProvider from 'payment-widget-core/tracker/openreplay'
import {settings} from '@/config/settings.js'

tracker.use(openReplayProvider)

if (settings.env.APP_OPEN_REPLAY_PROJECT_KEY && settings.env.APP_OPEN_REPLAY_INGEST_POINT) {
  const params = new URLSearchParams(window.location.search)
  const invoice = params.get('invoice_id')

  const rawIngestPoint = '/ingest'
  const ingestPoint = rawIngestPoint.startsWith('/')
    ? `${window.location.origin}${rawIngestPoint}`
    : rawIngestPoint

  tracker.init({
    openreplay: {
      revID: settings.env.APP_VERSION,
      projectKey: settings.env.APP_OPEN_REPLAY_PROJECT_KEY,
      ingestPoint,
      __DISABLE_SECURE_MODE: true,
    }
  })

  tracker.start({
    userID: invoice,
    metadata: Object.fromEntries(params.entries()),
  })
}
